import { EventEmitter, QueryList } from '@angular/core';
import { ChannelLimitation, ChannelStatus, CommonConstant, platformIconPath } from '../../app.constants';
import { WebUtils } from '../../utils/web.utils';
import { ReferenceDataService } from '../../services/reference-data/reference-data.service';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../services/user.service';
import { ModalService } from '../../services/modal/modal.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { ValidationHandlerService } from '../../core/validation-handler.service';
import { InfluencerChannelAuthorization } from '../../../models/authorize-channel';
import { AuthService } from '../../core/auth.service';
import { PlatformFieldComponent } from '../influencer-settings/platform-field/platform-field.component';
import { ActionDetails, ActionSource, EventTrackerService, Page, TargetType, UserActionType } from '../../services/event-tracker/event-tracker.service';
var CampaignAcceptionPopupComponent = /** @class */ (function () {
    function CampaignAcceptionPopupComponent(auth, influencerService, referenceDataService, validationHandlerService, activatedRoute, userService, modalService, eventTracker) {
        this.auth = auth;
        this.influencerService = influencerService;
        this.referenceDataService = referenceDataService;
        this.validationHandlerService = validationHandlerService;
        this.activatedRoute = activatedRoute;
        this.userService = userService;
        this.modalService = modalService;
        this.eventTracker = eventTracker;
        this.confirmChannel = new EventEmitter();
        this.maxChannelCanAdded = ChannelLimitation.MAX_CHANNEL_ADDED;
        this.channelErrors = [];
        this.platforms = [];
        this.listExistingChannel = [];
        this.listNewChannel = [];
        this.newChannelIndex = 0;
    }
    CampaignAcceptionPopupComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.channelList && changes.channelList.previousValue && changes.channelList.currentValue) {
            this.listExistingChannel = changes.channelList.currentValue;
            if (this.fbAuthError) {
                setTimeout(function () {
                    _this.handleFbAuthOnError();
                }, 200);
            }
            else {
                this.handleFbAuthOnSuccess();
            }
        }
    };
    CampaignAcceptionPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activatedRoute.params.subscribe(function (params) {
            _this.campaignId = Number(params.campaignId);
        });
        this.activatedRoute.queryParams.subscribe(function (params) {
            _this.accessToken = params.accessToken;
            _this.inviteToken = params.inviteToken;
            _this.permissionToken = params.permissionToken;
            _this.fbAuthError = params.error;
        });
        this.currentInfluencer = this.userService.getInfluencerInfo();
        this.platforms = this.referenceDataService.platforms;
        this.listExistingChannel = this.channelList;
        this.intializedChannelListFromLocalData();
    };
    CampaignAcceptionPopupComponent.prototype.intializedChannelListFromLocalData = function () {
        // get list new channel from caching data
        var localChannelAuthData = this.auth.getInfluencerChannelAuthorizationLocalData();
        if (!localChannelAuthData) {
            return;
        }
        if (localChannelAuthData.activeChannelId > 0) {
            this.authorizingIgChannelId = localChannelAuthData.activeChannelId;
        }
        else {
            this.authorizingNewIgChannelIndex = localChannelAuthData.activeChannelIndex;
        }
        this.previousAuthorizedChannels = localChannelAuthData.channelList.filter(function (ch) { return ch.id > 0; }).map(function (c) { return c.id; });
        // on error show all previous new channels
        if (this.fbAuthError) {
            this.listNewChannel = localChannelAuthData.channelList.filter(function (cn) { return cn.id === 0; })
                .map(function (c) { return Object.assign({}, c, {
                type: ChannelStatus.UNAUTHORIZE
            }); });
            var newChannelAuthorizing = this.listNewChannel.find(function (c) { return c.index === localChannelAuthData.activeChannelIndex; });
            if (newChannelAuthorizing) {
                newChannelAuthorizing.type = ChannelStatus.AUTHORIZE_FAILED;
            }
        }
        else {
            // on success, remove the previous success one
            this.listNewChannel = localChannelAuthData.channelList.filter(function (cn) { return cn.id === 0 && cn.index !== localChannelAuthData.activeChannelIndex; });
        }
    };
    CampaignAcceptionPopupComponent.prototype.handleFbAuthOnError = function () {
        var _this = this;
        var fieldError;
        var channelComp;
        if (this.authorizingIgChannelId > 0) {
            fieldError = this.authorizingIgChannelId.toString();
            channelComp = this.channelComponents.find(function (c) { return c.channelData.id === _this.authorizingIgChannelId; });
        }
        else {
            fieldError = "new_" + this.authorizingNewIgChannelIndex;
            channelComp = this.channelComponents.find(function (c) { return c.channelData.index === _this.authorizingNewIgChannelIndex; });
        }
        if (channelComp) {
            channelComp.platformSetting.status = ChannelStatus.AUTHORIZE_FAILED;
        }
        this.handleChannelError(fieldError, this.fbAuthError);
    };
    CampaignAcceptionPopupComponent.prototype.handleFbAuthOnSuccess = function () {
        var _this = this;
        if (this.authorizingIgChannelId > 0) {
            this.auth.saveAuthorizedChannelOnLocal(this.authorizingIgChannelId);
            var authorizedIgChannel = this.listExistingChannel.find(function (c) { return _this.authorizingIgChannelId === c.id; });
            // send MP event after authorizing IG channel
            if (authorizedIgChannel) {
                this.sendMpEvent(authorizedIgChannel.id, authorizedIgChannel.handle);
            }
        }
        else if (Array.isArray(this.previousAuthorizedChannels) && this.previousAuthorizedChannels.length > 0) {
            var authorizingChannel = this.listExistingChannel.find(function (c) { return _this.previousAuthorizedChannels.indexOf(c.id) < 0; });
            if (authorizingChannel) {
                // send MP event after authorizing IG channel
                this.auth.saveAuthorizedChannelOnLocal(authorizingChannel.id);
                this.sendMpEvent(authorizingChannel.id, authorizingChannel.handle);
            }
        }
    };
    CampaignAcceptionPopupComponent.prototype.onModifyChannel = function (evt) {
        var _this = this;
        if (evt.status === 'error') {
            // TODO will show error message following the new Mockup
            console.log("has error while adding channel " + evt.errorCode);
            this.handleChannelError(evt.fieldError, evt.errorCode);
        }
        else {
            // clear error
            this.channelErrors = this.channelErrors.filter(function (ce) { return ce.name !== evt.fieldName; });
            this.updateErrors(this.channelErrors);
            this.sendMpEvent(evt.data.id, evt.data.handle);
            setTimeout(function () {
                _this.reLoadInfluencerChannels(_this.currentInfluencer.id, function () {
                    if (evt.type === 'new') {
                        _this.listNewChannel = _this.listNewChannel.filter(function (nc) { return nc.handle !== evt.data.handle; });
                    }
                });
            }, 400);
        }
    };
    CampaignAcceptionPopupComponent.prototype.sendMpEvent = function (channelId, handle) {
        var target = {
            type: TargetType.CHANNEL,
            id: channelId,
            name: handle
        };
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CHANNEL, target, {
            actionDetails: ActionDetails.INFLUENCER_CONFIRM_CHANNEL,
            source: this.accessToken ? ActionSource.CAMPAIGN_LANDING_PAGE : ActionSource.INFLUENCER_APP,
            action: UserActionType.UPDATE
        }, undefined, null);
    };
    CampaignAcceptionPopupComponent.prototype.handleChannelError = function (fieldError, errorCode) {
        var existedError = this.channelErrors.find(function (ce) { return ce.name === fieldError; });
        if (existedError) {
            existedError.message = this.getMessageErrorKey(errorCode);
        }
        else {
            this.channelErrors.push({
                name: fieldError,
                message: this.getMessageErrorKey(errorCode)
            });
        }
        this.updateErrors(this.channelErrors);
    };
    CampaignAcceptionPopupComponent.prototype.updateErrors = function (errors) {
        this.validationHandlerService.updateErrors(errors);
        this.validationHandlerService.shouldDisplayErrors(true);
    };
    CampaignAcceptionPopupComponent.prototype.getMessageErrorKey = function (errorCode) {
        if (errorCode === CommonConstant.INFLUENCER_HANDLE_EXISTED) {
            return 'influencer_request.errors.handle_existed';
        }
        if (errorCode === CommonConstant.NO_BUSSINES_USER_ERROR) {
            return 'influencer_request.errors.no_business_user';
        }
        if (errorCode === CommonConstant.FACEBOOK_ERROR) {
            return 'influencer_request.errors.facebook_error';
        }
        if (errorCode === CommonConstant.INVALID_TOKEN) {
            return 'influencer_request.errors.invalid_token';
        }
        if (errorCode === CommonConstant.MISSING_TOKEN) {
            return 'influencer_request.errors.missing_token';
        }
        if (errorCode === CommonConstant.MISSING_CHANNEL) {
            return 'influencer_request.errors.missing_channel';
        }
        if (errorCode === CommonConstant.INVALID_CHANNEL) {
            return 'influencer_request.errors.invalid_channel';
        }
        if (errorCode === CommonConstant.NOT_OWN_CHANNEL) {
            return 'influencer_request.errors.not_own_channel';
        }
        if (errorCode === CommonConstant.CHANNEL_OWNED_BY_OTHERS) {
            return 'influencer_request.errors.channel_owned_by_others';
        }
        if (errorCode === CommonConstant.TOO_MANY_POSTS_TO_MERGE_OR_STEAL) {
            return 'influencer_request.errors.too_many_posts_to_merge_or_steal';
        }
        else {
            return 'influencer_request.errors.auth_fail';
        }
    };
    CampaignAcceptionPopupComponent.prototype.reLoadInfluencerChannels = function (influencerId, callback) {
        var _this = this;
        this.influencerService.getInfluencerChannels(influencerId).subscribe(function (res) {
            _this.listExistingChannel = res;
            if (callback) {
                callback();
            }
        });
    };
    CampaignAcceptionPopupComponent.prototype.authorizeChannel = function (evt) {
        if ((evt.channel === 'ig')) {
            var authData = new InfluencerChannelAuthorization();
            authData.campaignId = this.campaignId;
            authData.isAuthenticatedIGChannel = this.hasSelectedIGChannel;
            authData.accessToken = this.accessToken;
            authData.inviteToken = this.inviteToken;
            authData.permissionToken = this.permissionToken;
            authData.channelList = this.listChannel;
            authData.activeChannelId = evt.data.id;
            authData.activeChannelIndex = evt.data.index;
            this.auth.saveInfluencerChannelAuthorizationDataOnLocal(authData);
            if (authData.activeChannelId > 0) {
                this.auth.saveAuthorizedChannelOnLocal(authData.activeChannelId);
            }
            var currentUser = this.auth.getUser();
            if (currentUser) {
                var facebookAuthLink = WebUtils.igChannelAuthorizationLink(evt.data.id, this.currentInfluencer.id, evt.data.handle, currentUser.token, this.activePage);
                window.location.href = facebookAuthLink;
            }
        }
        else {
            this.onModifyChannel(evt);
        }
    };
    Object.defineProperty(CampaignAcceptionPopupComponent.prototype, "listChannel", {
        get: function () {
            var listChannel = [];
            listChannel.push.apply(listChannel, this.listExistingChannel);
            listChannel.push.apply(listChannel, this.listNewChannel);
            return listChannel;
        },
        enumerable: true,
        configurable: true
    });
    CampaignAcceptionPopupComponent.prototype.afterChangePlatform = function (evt) {
        var _this = this;
        if (this.listChannel && this.listChannel.length > ChannelLimitation.MAX_CHANNEL_ADDED) {
            this.isExceedLimtitation = true;
        }
        else if (this.selectedChannels) {
            this.listNewChannel.push({
                id: 0,
                handle: null,
                blogId: this.currentInfluencer.id,
                type: ChannelStatus.UNAUTHORIZE,
                relativePath: null,
                platform: this.platforms.find(function (pl) { return pl.id === _this.selectedChannels; }),
                youtubeType: null,
                index: this.newChannelIndex++
            });
            if (this.listChannel && this.listChannel.length > ChannelLimitation.MAX_CHANNEL_ADDED) {
                this.listNewChannel.pop();
                this.isExceedLimtitation = true;
            }
            else {
                this.selectedChannels = null;
                this.isExceedLimtitation = false;
            }
        }
    };
    CampaignAcceptionPopupComponent.prototype.onDeleteChannel = function (evt) {
        var _this = this;
        this.deletedChannel = evt;
        if (evt.isMobile) {
            this.deleteChannelWarningPopupRef = this.modalService.openInCenter(this.alertRemoveSocialMobile, function () {
                _this.deletedChannel = null;
            }, 'channel-auth-modal');
        }
        else {
            this.deleteChannelWarningPopupRef = this.modalService.openInCenter(this.alertRemoveSocial, function () {
                _this.deletedChannel = null;
            });
        }
    };
    CampaignAcceptionPopupComponent.prototype.closeDeleteChannelWarningPopup = function () {
        this.deletedChannel = null;
        this.modalService.closeSinglePopup(this.deleteChannelWarningPopupRef);
    };
    CampaignAcceptionPopupComponent.prototype.onChangeHandle = function (evt) {
        this.channelErrors = this.channelErrors.filter(function (ce) { return ce.name !== evt.fieldName; });
    };
    CampaignAcceptionPopupComponent.prototype.acceptDeleteChannel = function () {
        var _this = this;
        this.onCloseConfirmPopupBeforeDeletingChannel();
        this.isExceedLimtitation = false;
        // clear error on UI
        this.clearSpecificChannelError(this.deletedChannel.channel);
        // process to delete channel
        var deleteChannelId = this.deletedChannel.channel.id;
        // when deleting an new channel which doesn't save.
        if (deleteChannelId === 0) {
            this.listNewChannel = this.listNewChannel.filter(function (nc) { return nc.index !== _this.deletedChannel.channel.index; });
            return;
        }
        // keep the removed channel to rever if error happen
        var removedChannelIndex = this.listExistingChannel.findIndex(function (c) { return c.id === deleteChannelId; });
        var removedChannel = this.listExistingChannel[removedChannelIndex];
        // optimitis UI
        this.listExistingChannel = this.listExistingChannel.filter(function (c) { return c.id !== deleteChannelId; });
        this.influencerService.deleteInfluencerChannel(deleteChannelId).subscribe(function (res) {
        }, function (err) {
            // revert the change before
            _this.listExistingChannel.splice(removedChannelIndex, 0, removedChannel);
        });
    };
    CampaignAcceptionPopupComponent.prototype.clearSpecificChannelError = function (channel) {
        if (channel.id > 0) {
            this.channelErrors = this.channelErrors.filter(function (ce) { return ce.name !== String(channel.id); });
        }
        else {
            this.channelErrors = this.channelErrors.filter(function (ce) { return ce.name !== "new_" + channel.index; });
        }
        this.validationHandlerService.updateErrors(this.channelErrors);
    };
    CampaignAcceptionPopupComponent.prototype.onCloseConfirmPopupBeforeDeletingChannel = function () {
        if (this.deleteChannelWarningPopupRef) {
            this.modalService.closeSinglePopup(this.deleteChannelWarningPopupRef);
        }
    };
    CampaignAcceptionPopupComponent.prototype.onConfirm = function () {
        this.confirmChannel.emit(this.listChannel);
    };
    Object.defineProperty(CampaignAcceptionPopupComponent.prototype, "hasSelectedIGChannel", {
        get: function () {
            return this.listChannel.findIndex(function (newCN) { return newCN.platform.id === platformIconPath.instagram.id; }) >= 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignAcceptionPopupComponent.prototype, "numberOfAddedChannels", {
        get: function () {
            return this.listChannel.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignAcceptionPopupComponent.prototype, "isValidToSubmit", {
        get: function () {
            return this.listChannel && this.listChannel.length > 0 && this.listChannel.filter(function (cn) { return cn.type !== ChannelStatus.AUTHORIZED; }).length === 0;
        },
        enumerable: true,
        configurable: true
    });
    return CampaignAcceptionPopupComponent;
}());
export { CampaignAcceptionPopupComponent };



// WEBPACK FOOTER //
// ./src/app/influencer-platform/campaign-acception-popup/campaign-acception-popup.component.ts.pre-build-optimizer.js